export default "__VITE_ASSET___V0ENCDV__"